import { Button, MenuItem } from '@material-ui/core';
import * as AgentNewsAdministrationRouteConstants from 'AgentNewsAdministration/AgentNewsAdministrationRouteConstants';
import 'AgentNewsAdministration/components/AgentNewsAdministration.sass';
import AgentNewsAdministrationMenu from 'AgentNewsAdministration/components/AgentNewsAdministrationMenu';
import { changeNewsFilter, deleteNewsEntry, getNews, newsApiLink } from 'AgentNewsAdministration/ducks/news';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReducerState } from 'rootReducer';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import Column from 'Shared/components/PagedView/Column';
import { withDateFilterProperties, withStringFilterProperties } from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import { toFormattedDate } from 'Shared/utilities/DateFormatter';
import { withValueChangedHook } from 'Shared/utilities/withValueChanged';
import { addFilterParameters } from "Shared/utilities/addFilterParameters";
import { EmptyAgentNewsFilter } from 'AgentNewsAdministration/models/AgentNewsFilter';


const AgentNewsAdministration = () => {
  const { news, filter } = useSelector((state: ReducerState) => state.agentNewsAdministration.news);
  const dispatch = useDispatch();
  const changeFilter = withValueChangedHook({ ...filter, ['pageNumber']: '1' }, changeNewsFilter, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: filter,
  };

  useEffect(() => {
        dispatch(getNews(undefined, filter));
  }, [getNews, filter]);

  useEffect(() => {
    dispatch(changeNewsFilter({...EmptyAgentNewsFilter, pageNumber: '1'}))
}, [changeNewsFilter]);

  return (
    <PagedView
      pagedViewKey="agentNewsAdministration"
      loadMore={page => {
        const nextPage: number = parseInt(filter.pageNumber) + 1;
        if (Math.ceil(page.totalCount / parseInt(filter.pageSize)) > parseInt(filter.pageNumber)) {
            filter.pageNumber = nextPage.toString();
            let link = addFilterParameters(filter);
            page.links = [{
             "href": newsApiLink + link,
             "method": "GET",
             "rel": "nextpage",
            }]
        }
        dispatch(getNews(page, filter));
      }}
      actions={<AgentNewsAdministrationMenu />}
      data={news}
    >
      {columnProps => (
        <>
          <Column
            {...columnProps}
            title="Title"
            filterProperties={withStringFilterProperties(filterProperties, 'title')}
            default
          >
            {newsEntry => newsEntry.title}
          </Column>
          <Column
            {...columnProps}
            title="Description"
            filterProperties={withStringFilterProperties(filterProperties, 'description')}
            default
          >
            {newsEntry => newsEntry.description}
          </Column>
          <Column
            {...columnProps}
            title="Publish Date"
            filterProperties={withDateFilterProperties(filterProperties, 'publishDate')}
            default
          >
            {newsEntry => toFormattedDate(newsEntry.publishDate)}
          </Column>
          <Column {...columnProps} title="" isActions default>
            {newsEntry => (
              <>
                <Link to={AgentNewsAdministrationRouteConstants.NewsAdministrationEntry(newsEntry.id!)}>
                  <Button className="primary-action-button" color="primary">
                    Edit
                  </Button>
                </Link>
                <ActionsMenu>
                  <MenuItem onClick={() => dispatch(deleteNewsEntry(newsEntry.id!))}>Delete</MenuItem>
                </ActionsMenu>
              </>
            )}
          </Column>
        </>
      )}
    </PagedView>
  );
};

export default AgentNewsAdministration;
